/**
 * The checkout body for one product from the customer catalog.
 *
 * `palletSizeId` and the two notes send null rather than being omitted — this
 * is a create, so there is no saved row to fall back to and null is simply
 * "none".
 */
export const buildCustomerOrderPayload = (input: {
  productId: string;
  loadOptionId: string;
  deliveryType?: string | null;
  palletId: string;
  addressId: string;
  note: string;
  poNumber: string;
  quantity: number;
  // How many identical loads to place; each becomes its own load number.
  numberOfLoads?: number;
}) => ({
  productId: input.productId,
  loadOptionId: input.loadOptionId,
  palletSizeId: input.deliveryType === 'PALLET' ? input.palletId : null,
  deliveryAddressId: input.addressId,
  note: input.note.trim() || null,
  poNumber: input.poNumber.trim() || null,
  quantity: input.quantity || 0,
  numberOfLoads: Math.max(1, Math.floor(input.numberOfLoads || 1)),
});
